import { useState } from 'react';
import { useSelector } from 'react-redux';
import { ApiBackendClient } from '../../helpers/api_backend_helper';
import { RECEPCION_VEHICULO_CREAR } from '../../helpers/url_helper';

const useCreateRecepcionVehiculo = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const tenantId = useSelector((state) => state.Context.tenantId);
    const empresa = useSelector((state) => state.Context.empresa);
    const departamento = useSelector((state) => state.Context.departamento);
    const userInfo = useSelector((state) => state.UserInfo.userInfo);

    const apiBackendClient = new ApiBackendClient();

    const createRecepcion = async (datosRecepcion) => {
        setLoading(true);
        setError(null);
        try {
            console.log('Datos a guardar:', datosRecepcion);
            const response = await apiBackendClient.create(RECEPCION_VEHICULO_CREAR, {
                datosRecepcion,
                tenantId,
                empresa,
                departamento,
                usuario: userInfo?.name
            });
            console.log('Response from API:', response);
            if (response.id_recep) {
                const result = response;
                console.log('Recepción creada con éxito:', result);
                return { success: true, data: result };
            } else {
                throw new Error(response.message || 'Error al guardar la recepción');
            }
        } catch (err) {
            const errorMessage = `Failed to create recepcion: ${err.message || 'Unknown error'}`;
            setError(errorMessage);
            console.error(errorMessage);
            return { success: false, error: errorMessage };
        } finally {
            setLoading(false);
        }
    };

    return { createRecepcion, loading, error };
};

export default useCreateRecepcionVehiculo;